<template>
	<div class="d-flex flex-column justify-content-center" style="height:100vh">
		<div class="p-3 d-flex justify-content-center">		
            <div class="shadow rounded"> 
                <h2 class="p-3 mb-5 text-success"> Vidduka | Register</h2>                                
                <content>                      
                    <div>			 
                        <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
                            <li class="nav-item">
                                <a class="nav-link active" 
                                    id="pills-home-tab" 
                                    data-toggle="pill" 
                                    href="#pills-home" 
                                    role="tab" 
                                    aria-controls="pills-home" 
                                    aria-selected="true">
                                                            
                                    Business Details
                                </a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" 
                                    id="pill-personal-tab" 
                                    data-toggle="pill" 
                                    href="#pill-personal" 
                                    role="tab" 
                                    aria-controls="pill-personal" 
                                    aria-selected="false"
                                    @click="checkBusinessDetails()">
                                    Personal Details
                                </a>
                            </li>                            							
                        </ul>						
                        <div class="tab-content" id="pills-tabContent">
                            <div class="tab-pane fade show active" 
                                id="pills-home" 
                                role="tabpanel" 
                                aria-labelledby="pills-home-tab">                                
                                <ul v-if="business_detail_errors.length" class="text-center list-unstyled">
                                    <li v-for="error in business_detail_errors" :key="error">
                                        <small class="text-danger">{{ error }}</small>
                                    </li>
                                </ul>                              
                                <div class="p-4">                                    
                                    <div class="form-group">
                                        <label class="font-weight-bold">Business Name</label>
                                        <input type="text" class="form-control"
                                                :class="{'has-error': ! business_name &&  business_detail_errors.length}"
                                                placeholder="A name for your business" 
                                                v-model="business_name">
                                    </div>
                                    <div class="form-group">
                                        <label class="font-weight-bold">Email</label>
                                        <input type="email" class="form-control"
                                                :class="{'has-error': ! business_email &&  business_detail_errors.length }"
                                                placeholder="Business email" 
                                                v-model="business_email">                    					                   
                                    </div>
                                    <div class="form-group">
                                        <label class="font-weight-bold">Phone number</label>
                                        <input type="text" class="form-control"
                                                :class="{'has-error': ! business_phone &&  business_detail_errors.length}"
                                                placeholder="Business phone number" 
                                                v-model="business_phone">                    					                   
                                    </div>
                                    <!-- /.submit button -->
                                    <div class="d-flex justify-content-end">
                                        <button class="btn btn-success btn-flat"
                                            @click="checkBusinessDetails()">
                                            Next
                                        </button>
                                    </div>
                                    <div class="mt-3 d-flex flex-column">
                                        <router-link to="/login" class="text-center">Already have an account? Login</router-link>                                        
                                    </div>
                                </div>
                            </div>
                            <div class="tab-pane fade" id="pill-personal" role="tabpanel" aria-labelledby="pill-personal-tab">
                                <ul v-if="business_detail_errors.length" class="text-center list-unstyled">
                                    <li v-for="error in business_detail_errors" :key="error">
                                        <small class="text-danger">{{ error }}</small>
                                    </li>
                                </ul>
                                <ul v-if="personal_detail_errors.length" class="text-center list-unstyled">
                                    <li v-for="error in personal_detail_errors" :key="error">
                                        <small class="text-danger">{{ error }}</small>
                                    </li>
                                </ul>
                                <ul v-if="signup_info.length" class="text-center list-unstyled">
                                    <li v-for="error in signup_info" :key="error" class="text-info">
                                        <small>{{ error }}</small>
                                    </li>
                                </ul>
                                <div class="p-4">
                                        <div class="form-group">
                                            <label class="font-weight-bold">First name</label>
                                            <input type="text" class="form-control"
                                                    :class="{'has-error': ! first_name &&  personal_detail_errors.length}"
                                                    placeholder="your first name" 
                                                    v-model="first_name">
                                        </div>
                                        <div class="form-group">
                                            <label class="font-weight-bold">Last name</label>
                                            <input type="text" class="form-control"
                                                    :class="{'has-error': ! last_name &&  personal_detail_errors.length}"
                                                    placeholder="your last name" 
                                                    v-model="last_name">
                                        </div>
                                        <div class="form-group">
                                            <label class="font-weight-bold">Password</label>
                                            <input type="password" class="form-control"
                                                    :class="{'has-error': (! password || password != password_confirmation) &&  personal_detail_errors.length}"
                                                    placeholder="set a password" 
                                                    v-model="password">
                                        </div>
                                        <div class="form-group">
                                            <label class="font-weight-bold">Confirm password</label>
                                            <input type="password" class="form-control"
                                                    :class="{'has-error': (! password_confirmation || password != password_confirmation) &&  personal_detail_errors.length}"
                                                    placeholder="confirm password" 
                                                    v-model="password_confirmation">
                                        </div>
                                        <!-- /.submit button -->
                                        <div class="mt-3">
                                            <button class="btn btn-success btn-block btn-flat"
                                                @click="checkPersonalDetails()">
                                                Sign up
                                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="registering"></span>
                                            </button>
                                        </div>
                                </div>
                            </div>                        
                        </div> 		  
                    </div>		        		  
                </content>        
            </div>
		</div>
	</div>   
</template>
<script>
import router from "@/router";
export default {
	name: 'register',
	data() {
	return {     
		//form data   				
		business_name: null,
        business_email: null,
        business_phone:null,
        //view state
        first_name: null,
        last_name: null,
        password: null,
        password_confirmation : null,
        //errors
        business_detail_errors: [],
        personal_detail_errors: [],	
        //info
        registering: false,
        signup_info:[],
		//logged in user
		logged_in_user:null,
		logged_in_user_location_id:null
	}
	},	
	methods: {	
    validateEmail: function(email){
        return String(email)
            .toLowerCase()
            .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            )
    },
    validatePhonenumber: function(phone){        
        return String(phone).match(/^\d{10}$/)
    },
    checkBusinessDetails: function(){
        this.business_detail_errors = []
        if (this.business_name && this.business_phone && this.business_email){
            document.getElementById('pill-personal-tab').click()
        }
        else{                        
            this.business_detail_errors.push("All business detail fields are required")            
        }
        if (! this.validateEmail(this.business_email)){
            this.business_detail_errors = []
            this.business_detail_errors.push("Invalid Email")
        }
        if (! this.validatePhonenumber(this.business_phone)){
            this.business_detail_errors = []
            this.business_detail_errors.push("Invalid Phonenumber")
        }
    },
    //check personal details.
    checkPersonalDetails: function(){
        this.peronal_detail_errors = []
        if (this.password && this.password_confirmation && this.first_name && this.last_name){            
            if (this.password !== this.password_confirmation){
                this.personal_detail_errors.push("Password confirmation does not match password") 
            }
            else{
                this.regiterBusiness()
            }
        }       
        else{                        
            this.personal_detail_errors.push("All personal detail fields are required")            
        }
    },
	//get access token
	regiterBusiness: function () { 
        this.registering = true
		//clear errors and info   		
        this.business_detail_errors =  []
		this.personal_detail_errors = []
		//register.
		this.signup_info.push("signing up...")		
		this.$http({
			method: 'post',
			url: this.$API_BASE_URL + `/HJYBCFRB/${this.$version}/core/business-details/`,
			data: {
                business: {
                    name: this.business_name,
                    email: this.business_email,
                    phone: this.business_phone,                    
                },
                first_name: this.first_name,
                last_name: this.last_name,
                password: this.password_confirmation
            }
			}).then(() => {
                this.registering = false
                //clear errors and info                
				this.signup_info = []
                this.login_error = []
                router.push("/login")
				//update view state

			}).catch((err) => {
                this.registering = false
				//clear errors and info
                this.signup_info = []                
                var response = err.response

                if (response.data.message){
                    this.business_detail_errors.push(response.data.message)
                }                      
			})
	},
	//inform App.vue of a new login
	emitToParent () {     		                        
		this.$emit('newLogin', this.logged_in_user)
	},
	}
}
</script>